/**
 * Country Redirect
 *
 * Intercepts country-selector link clicks and redirects to the correct
 * product (or collection) handle on the target market domain, using
 * JSON metafield data rendered in #country-redirect-data.
 */

function getRedirectData() {
  const el = document.getElementById('country-redirect-data');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    console.error('[CountryRedirect] Failed to parse redirect data', e);
    return null;
  }
}

function getProductRedirectUrl(countryCode, baseUrl, redirects) {
  const handle = redirects[countryCode];
  if (!handle) return null;

  try {
    const url = new URL(baseUrl);
    url.pathname = '/products/' + handle;
    return url.toString();
  } catch (e) {
    return null;
  }
}

function getPageRedirectUrl(countryCode, baseUrl, redirects) {
  const handle = redirects[countryCode];
  if (!handle) return null;

  try {
    const url = new URL(baseUrl);
    url.pathname = '/pages/' + handle;
    return url.toString();
  } catch (e) {
    return null;
  }
}

function getCollectionRedirectUrl(countryCode, baseUrl, redirects) {
  const handle = redirects[countryCode];
  if (!handle) return null;

  try {
    const url = new URL(baseUrl);
    url.pathname = '/collections/' + handle;
    return url.toString();
  } catch (e) {
    return null;
  }
}

function getBlogRedirectUrl(countryCode, baseUrl, redirects) {
  const handle = redirects[countryCode];
  if (!handle) return null;

  try {
    const url = new URL(baseUrl);
    url.pathname = '/blogs/' + handle;
    return url.toString();
  } catch (e) {
    return null;
  }
}

function getArticleRedirectUrl(countryCode, baseUrl, redirects) {
  const blogArticlePath = redirects[countryCode];
  if (!blogArticlePath) return null;

  try {
    const url = new URL(baseUrl);
    url.pathname = '/blogs/' + blogArticlePath;
    return url.toString();
  } catch (e) {
    return null;
  }
}

function getRedirectUrl(countryCode, baseUrl, data) {
  if (data.pageType === 'product') {
    return getProductRedirectUrl(countryCode, baseUrl, data.redirects);
  }
  if (data.pageType === 'page') {
    return getPageRedirectUrl(countryCode, baseUrl, data.redirects);
  }
  if (data.pageType === 'collection') {
    return getCollectionRedirectUrl(countryCode, baseUrl, data.redirects);
  }
  if (data.pageType === 'blog') {
    return getBlogRedirectUrl(countryCode, baseUrl, data.redirects);
  }
  if (data.pageType === 'article') {
    return getArticleRedirectUrl(countryCode, baseUrl, data.redirects);
  }
  return null;
}

function init() {
  const data = getRedirectData();
  if (!data) return;

  document.addEventListener('click', function (e) {
    const link = e.target.closest('a.js-country-link[data-country-code]');
    if (!link) return;

    const countryCode = link.dataset.countryCode;
    const redirectUrl = getRedirectUrl(countryCode, link.href, data);

    if (redirectUrl) {
      e.preventDefault();
      window.location.href = redirectUrl;
    }
    // If no redirect found, the default link behaviour proceeds (goes to the market root)
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
